var siteExitModal = new bootstrap.Modal('#site-exit-modal');

$(document).on('click', 'a[href^="//"], a[href^="http"]', function(e) {
	// Skip internal links
	if (this.href.includes(window.location.hostname)) return;

	//Hide the exit dialog
	if ($(this).prop('id') === 'site-exit-modal-continue') {
		if($(this).prop('target') === '_blank') $('#site-exit-modal').modal('hide');
		return;
	}

	var link = $(this).attr('href');
	var target = $(this).attr('target');

	if (link == 'javascript:void(0)' || link.toString().startsWith("#")){
		return false;
	}

	if (isTrustedDomain(link)) return;

	showExitModal({url: link, target: target});
	e.preventDefault();
})

function showExitModal(exclusionCheckResult){
	$('#site-exit-modal-continue').prop('href',exclusionCheckResult.url)
	$('#site-exit-modal-continue').prop('target',exclusionCheckResult.target)
	if(exclusionCheckResult.target === '_blank') $('#site-exit-modal-target-notice').removeClass();
	else $('#site-exit-modal-target-notice').prop('class','d-none');
	siteExitModal.show();
	document.querySelector('#site-exit-modal-continue').addEventListener('click',function () { siteExitModal.hide() });
}

function isTrustedDomain(url) {
	const domain = getDomainFromUrl(url);
	if (!domain) return false;
	const domainHash = hashDomain(domain);
	const result = lotdh.includes(domainHash);
	return result;
}

function normalizeDomain(domain) {
	return domain.replace(/^www\./, '').toLowerCase();
}

function getDomainFromUrl(url) {
	try {
		return new URL(url, window.location.href).hostname;
	} catch (e) {
		return null;
	}
}

function hashDomain(domain) {
	const normalized = normalizeDomain(domain);
	const hash = sha256(normalized);
	return hash;
}

function sha256(text) {
	const rightRotate = function(value, amount) {
		return (value >>> amount) | (value << (32 - amount));
	};
	const mathPow = Math.pow;
	const maxWord = mathPow(2, 32);
	const lengthProperty = 'length';
	const words = [];
	const initialHash = sha256.h = sha256.h || [];
	const k = sha256.k = sha256.k || [];
	let primeCounter = k[lengthProperty];
	let isComposite = {};
	let result = '';
	let ascii = unescape(encodeURIComponent(text));
	const asciiBitLength = ascii[lengthProperty] * 8;
	let hash;
	let i;
	let j;

	for (let candidate = 2; primeCounter < 64; candidate++) {
		if (!isComposite[candidate]) {
			for (i = 0; i < 313; i += candidate) {
				isComposite[i] = candidate;
			}
			initialHash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
			k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
		}
	}

	ascii += '\x80';
	while (ascii[lengthProperty] % 64 - 56) ascii += '\x00';

	for (i = 0; i < ascii[lengthProperty]; i++) {
		j = ascii.charCodeAt(i);
		words[i >> 2] |= j << ((3 - i) % 4) * 8;
	}
	words[words[lengthProperty]] = (asciiBitLength / maxWord) | 0;
	words[words[lengthProperty]] = asciiBitLength;

	hash = initialHash.slice(0);

	for (j = 0; j < words[lengthProperty];) {
		const w = words.slice(j, j += 16);
		const oldHash = hash.slice(0);

		for (i = 0; i < 64; i++) {
			const w15 = w[i - 15];
			const w2 = w[i - 2];
			const a = hash[0];
			const e = hash[4];
			const temp1 = hash[7]
				+ (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25))
				+ ((e & hash[5]) ^ ((~e) & hash[6]))
				+ k[i]
				+ (w[i] = (i < 16) ? w[i] : (
					w[i - 16]
					+ (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3))
					+ w[i - 7]
					+ (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10))
				) | 0);
			const temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22))
				+ ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]));

			hash.unshift((temp1 + temp2) | 0);
			hash[4] = (hash[4] + temp1) | 0;
			hash.pop();
		}

		for (i = 0; i < 8; i++) {
			hash[i] = (hash[i] + oldHash[i]) | 0;
		}
	}

	for (i = 0; i < 8; i++) {
		for (j = 3; j + 1; j--) {
			const b = (hash[i] >> (j * 8)) & 255;
			result += ((b < 16) ? 0 : '') + b.toString(16);
		}
	}

	return result;
}
